
import { Component, Vue } from 'vue-property-decorator';
import { StayRoomModule } from '@/store/modules/stayRoom';

@Component({
  components: {
  },
})
export default class extends Vue {
  get formData() {
    return StayRoomModule.form;
  }

  private activePricePart = 'basic';

  private pricePartSettingVisible = false;

  private handleVisiblePartSetting() {
    this.pricePartSettingVisible = !this.pricePartSettingVisible;
  }

  private getActiveRoomPrice() {
    if (!this.activePricePart) {
      return this.formData.roomPrice;
    }
    return this.formData.pricePartList[this.activePricePart].roomPrice;
  }
}
